<template>
  <wgu-module-card v-bind="$attrs" :moduleName="moduleName" class="wgu-attributetable-win" :icon="icon">

    <template v-slot:wgu-win-toolbar>
      <v-select v-model="selYear" color="accent" item-color="secondary" :dark="isPrimaryDark" filled outlined
        class="wgu-vector-layer-select wgu-solo-field" :items="appOptions" :item-text="item => item.name" :menu-props="{
          bottom: true,
          'offset-y': true,
        }" dense return-object hide-details :label="$t('wgu-attributetable.selectorLabel')"></v-select>
    </template>

    <ks-disastertable v-if="selYear" :layerId="selYear" :syncTableMapSelection="syncTableMapSelection" :rowsPerPage=6>
    </ks-disastertable>
  </wgu-module-card>
</template>

<script>
import ModuleCard from './../modulecore/ModuleCard';
import { Mapable } from '../../mixins/Mapable';
import { ColorTheme } from '../../mixins/ColorTheme';
import VectorLayer from 'ol/layer/Vector'
import DisasterTable from './DisasterTable';
import axios from '@/axios';

export default {
  name: 'ks-disastertable-win',
  inheritAttrs: false,

  props: {
    icon: { type: String, required: false, default: 'table_chart' },
    syncTableMapSelection: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      moduleName: 'ks-disastertable',
      selYears: [],
      layers: [],
      selYear: this.$store.state.selectedYear,
      optionData: null
    }
  },
  mixins: [Mapable, ColorTheme],
  components: {
    'wgu-module-card': ModuleCard,
    'ks-disastertable': DisasterTable
  },
  // when the component is mounted, query the disasters date from the server and then render the table and map
  mounted () {
    // this.fetchOptions();
  },
  activated () {
    console.log('Component is activated');
    // You can put any code here that should run when the component is activated
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound () {
      this.layers = this.map.getLayers().getArray();
    },
    /**
     * Fetch the options from the server.
     */
    async fetchOptions () {
      try {
        const optionUrl = '/?_c=api&_a=getOptions';
        const response = await axios.post(optionUrl, {
          username: this.username
        });

        if (!response || !response.data) {
          throw new Error('Invalid response from server');
        }

        console.log(response.data);
        this.optionData = response.data;

        // Default years if API doesn't return year data
        const selYears = [
          { name: '2020年', value: '2020' },
          { name: '2021年', value: '2021' },
          { name: '2022年', value: '2022' },
          { name: '2023年', value: '2023' }
        ];
        this.selYears = selYears;
      } catch (error) {
        console.error('Failed to fetch options:', error);
      }
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers vector layers to be shown in the selection menu.
     */
    displayedLayers () {
      return this.layers
        .filter(layer =>
          layer instanceof VectorLayer &&
          layer.get('lid') !== 'wgu-measure-layer' &&
          layer.get('lid') !== 'wgu-geolocator-layer'
        )
        .reverse();
    },
    /**
     * Reactive property to return the current options of the app.
     */
    appOptions () {
      return this.selYears;
    }
  }
};
</script>

<style scoped>
/* TODO
    Generalize the positioning concept for windows,
    this interferes with positioning and draggable settings in the app.conf */

.wgu-attributetable-win.wgu-floating {
  top: inherit !important;
  position: relative;
  bottom: 35px;
}

@media only screen and (max-width: 600px) {
  .wgu-attributetable-win.wgu-floating {
    bottom: 33px;
    height: 100%;
  }
}
</style>
